import { Button } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

interface IAddPeopleButtonProps {
  onClickAddPeopleButton: () => void;
}

export function AddPeopleButton({
  onClickAddPeopleButton,
}: IAddPeopleButtonProps): JSX.Element {
  return (
    <Button
      variant="primary"
      buttonSize="medium"
      block
      onClick={() => onClickAddPeopleButton()}
    >
      Add people
    </Button>
  );
}
